import axios from "~/utils/api";

export const searchApi = {
  getCustomerSearch: (params) =>
    axios.get(`/customer/search`, {params}),
};